import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng/errorBoundary';
import { rel } from '../../../../utils/rel';

class Tabs extends React.PureComponent {
    static propTypes = {
        children: PropTypes.any,
    };

    state = {
        current: 0,
    };

    handleMouseOver = e => {
        const index = Number(e.currentTarget.getAttribute('index'));

        if (index !== this.state.current) {
            this.setState({
                current: index,
            });
        }
    };

    renderTabHead = () => {
        const { current } = this.state;

        return (
            <div className={styles.tabHead}>
                {React.Children.map(this.props.children, (item, index) => {
                    return (
                        <div
                            className={`${styles.tabHeadItem} ${index === current ? styles.current : ''}`}
                            key={index}
                            index={index}
                            onMouseOver={this.handleMouseOver}>
                            <a href={item.props.url} target="_blank" rel={rel}>
                                {item.props.title}
                            </a>
                        </div>
                    );
                })}
            </div>
        );
    };

    renderBody() {
        return (
            <div className={styles.tabBody}>
                {React.Children.map(this.props.children, (item, index) =>
                    React.cloneElement(item, { active: this.state.current === index }),
                )}
            </div>
        );
    }

    /**
     * 渲染组件
     */
    render() {
        return (
            <div id="tabs">
                {this.renderTabHead()}
                {this.renderBody()}
            </div>
        );
    }
}

export default errorBoundary(Tabs);
